import { BANK_MAP } from '../utils/data';

const getBankInfo = (code) => {
  const bankData = BANK_MAP[code];

  // 1. Hàm phân loại màu sắc (Theme) - Giữ nguyên logic nhóm của bạn
  const getTheme = (bankCode) => {
    if (["970436", "970407", "970415", "970418", "970437"].includes(bankCode))
      return { color: "text-red-700", bg: "bg-red-50" };

    if (
      ["970422", "970416", "970418", "970406", "970403", "970431"].includes(
        bankCode,
      )
    )
      return { color: "text-blue-700", bg: "bg-blue-50" };

    if (["970405", "970432", "970499", "01204001", "970454"].includes(bankCode))
      return { color: "text-emerald-700", bg: "bg-emerald-50" };

    if (["970441", "970443", "970440"].includes(bankCode))
      return { color: "text-orange-700", bg: "bg-orange-50" };

    if (["970423", "970426", "546034"].includes(bankCode))
      return { color: "text-purple-700", bg: "bg-purple-50" };

    if (["970448", "970425", "970428"].includes(bankCode))
      return { color: "text-cyan-700", bg: "bg-cyan-50" };

    if (["971005", "971011", "963388", "971025"].includes(bankCode))
      return { color: "text-pink-700", bg: "bg-pink-50" };

    return { color: "text-slate-700", bg: "bg-slate-100" };
  };

  const theme = getTheme(code);

  // 2. Xử lý fallback khi không tìm thấy dữ liệu ngân hàng
  if (!bankData) {
    return {
      name: code ? `Ngân hàng (${code})` : "Không xác định",
      logo: null, // Hoặc một icon placeholder mặc định
      color: "text-slate-500",
      bg: "bg-slate-100",
    };
  }

  return {
    name: bankData.name,
    logo: bankData.logo,
    color: theme.color,
    bg: theme.bg,
  };
};

export default getBankInfo;

export const getPriorityStyle = (priority) => {
  switch (priority) {
    case "URGENT":
      return "bg-red-50 text-red-800 border-red-200 ring-1 ring-red-100";
    case "HIGH":
      return "bg-orange-50 text-orange-800 border-orange-200 ring-1 ring-orange-100";
    case "MEDIUM":
      return "bg-yellow-50 text-yellow-800 border-yellow-200";
    case "LOW":
      return "bg-blue-50 text-blue-700 border-blue-200";
    default:
      return "bg-slate-50 text-slate-700 border-slate-200";
  }
};

export const getDriverValue = (drivers, key) => {
  if (!drivers || !Array.isArray(drivers)) return "N/A";
  const driver = drivers.find((d) => d.k === key);
  return driver ? driver.v : "N/A";
};


// Helper tính phần trăm an toàn
export const calculatePercent = (part, total) => {
  if (!total || total === 0) return 0;
  return ((part / total) * 100).toFixed(1);
};


export const StatsSkeleton = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
    {[1, 2, 3, 4].map((i) => (
      <div
        key={i}
        className="h-32 bg-slate-200 animate-pulse rounded-2xl border border-slate-100"
      ></div>
    ))}
  </div>
);